// IMPORT JOB TO SCREENING ******************************************************
// pathname: /v1/screening/jobs/{jobSlug}/import
// ************************************************************************************************
import useSWRMutation from 'swr/mutation';
import { fetcher } from '@utils/data-fetching/fetcher';
import type { ApiSchema } from '@type/api/apiUtilityFn';

type JobOutput = ApiSchema<'JobOutput'>;

interface TriggerArgs {
  jobSlug: string;
}

/**
 * @description SWR Mutation: Import a job to the screening backend.
 * jobSlug is passed dynamically via trigger() since it's not known at hook initialization.
 */
export const useSwrImportJob = () => {
  const { data, error, isMutating, reset, trigger } = useSWRMutation(
    'screening-import-job',
    async (_key: string, { arg }: { arg: TriggerArgs }) => fetcher<JobOutput>(
      `/v1/screening/jobs/${arg.jobSlug}/import`,
      undefined,
      {
        method: 'POST',
      },
    ),
  );

  return {
    data,
    error,
    isMutating,
    reset,
    trigger,
  };
};
